import { render, staticRenderFns } from "./useRegistryMain.vue?vue&type=template&id=be7855da&scoped=true"
import script from "./useRegistryMain.vue?vue&type=script&lang=js"
export * from "./useRegistryMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7855da",
  null
  
)

export default component.exports